// extracted by mini-css-extract-plugin
export default {"main":"loader_main__PLcA6","inlineLoader":"loader_inlineLoader__WmYJn"};